import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';

enum Index {
  Home = 0,
  KWAIFUNG = 1,
  YUENLONG = 2,
  KWUN_TONG = 3,
  SHEK_MUN = 4,
}

const whatsappIcon = './static/icons/whatsapp.svg';
const bookingWhatsappUrl = 'https://wa.me/85296671254?text=我想搵醫師幫手呀！';

// 診所資料配置
const CLINIC_DATA: Record<
  Exclude<Index, Index.Home>,
  {
    name: string;
    title: string;
    address?: string;
    phone: string;
    phoneLink: string;
    directions?: string | string[];
    mapUrl?: string;
  }
> = {
  [Index.KWAIFUNG]: {
    name: '葵芳',
    title: '聖賢堂（葵芳）診所',
    address: '新界葵芳興芳路223號新都會廣場一期21樓2113-2114室',
    phone: '23332025',
    phoneLink: 'tel:+85223332025',
    directions:
      '葵芳站E出口直行至新都會廣場﹐乘電梯到二樓經奇華餅家側通道進入新都會廣場一期電梯大堂便到達。',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3689.884330250841!2d114.12670299999999!3d22.357996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403f9238a9e6265%3A0x8e3237be536203e9!2z5b-g6Yar6Ki65omAIOiBluizouWggg!5e0!3m2!1szh-TW!2shk!4v1679752074702!5m2!1szh-TW!2shk',
  },
  [Index.YUENLONG]: {
    name: '元朗',
    title: '聖賢堂（元朗）診所',
    address: '元朗青山公路-元朗段2號保安樓地下E及G舖',
    phone: '24683668',
    phoneLink: 'tel:+85224683668',
    directions: [
      '搭乘輕鐵到大棠路站,落車後找到恆香餅家後,左手面一路直行至街尾天橋使到達(途經快樂蜂,OK便利店,中國銀行)',
    ],
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3687.584981250768!2d114.03005479999999!3d22.4446413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403f14386153931%3A0xe72e62f9bc7dd14b!2z5b-g6Yar6Ki65omAIOiBluizouWggg!5e0!3m2!1szh-TW!2shk!4v1679752108602!5m2!1szh-TW!2shk',
  },
  [Index.KWUN_TONG]: {
    name: '觀塘',
    title: '聖賢堂（觀塘）診所',
    address: '觀塘觀塘道418號創紀之城5期-東亞銀行中心16樓08室(APM樓上)',
    phone: '23236992',
    phoneLink: 'tel:+85223236992',
    directions: [
      '港鐵觀塘線觀塘站B1出口，步行約3分鐘即可到達',
      '搭乘巴士：11D、23、74X、80、80X、83X、93A、268C、269C 於觀塘站下車',
    ],
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.1675811137287!2d114.22324571495943!3d22.31198048531783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34040146c53f4d0f%3A0x11e5c0932f4b501e!2z5b-g6Yar6Ki65omAIOimluWhnuWggg!5e0!3m2!1szh-TW!2shk!4v1679752108602!5m2!1szh-TW!2shk',
  },
  [Index.SHEK_MUN]: {
    name: '石門',
    title: '聖賢堂（石門）診所',
    address: '沙田石門安耀街5號 W LUXE大廈23樓N1',
    phone: '2412 3466',
    phoneLink: 'tel:+85224123466',
    directions: [
      '石門地鐵站C出口直行到安群街右轉直行到安耀街，直望便到達W LUXE',
    ],
    mapUrl:
      'https://www.google.com/maps?q=%E6%B2%99%E7%94%B0%E7%9F%B3%E9%96%80%E5%AE%89%E8%80%80%E8%A1%975%E8%99%9F%20W%20LUXE%E5%A4%A7%E5%BB%8823%E6%A8%93N1&output=embed',
  },
};

const CLINIC_INDEXES: Exclude<Index, Index.Home>[] = [
  Index.KWAIFUNG,
  Index.YUENLONG,
  Index.KWUN_TONG,
  Index.SHEK_MUN,
];

// 可重用的圖標組件
const ArrowLeftIcon = () => (
  <svg
    aria-describedby="desc"
    aria-labelledby="title"
    role="img"
    width="18"
    height="18"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Indicator Left</title>
    <desc>A solid styled icon from Orion Icon Library.</desc>
    <path
      d="M25.121 47.121L11.128 33.128l-.012-.012L9 31l16.121-16.121a3 3 0 0 1 4.242 4.242l-8.879 8.88h29.517a3 3 0 1 1 0 6H20.486l8.877 8.878a3 3 0 0 1-4.242 4.242z"
      data-name="layer1"
      fill="white"
    />
  </svg>
);

const PhoneIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 202.592 202.592"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M198.048,160.105l-31.286-31.29c-6.231-6.206-16.552-6.016-23.001,0.433l-15.761,15.761
			c-0.995-0.551-2.026-1.124-3.11-1.732c-9.953-5.515-23.577-13.074-37.914-27.421C72.599,101.48,65.03,87.834,59.5,77.874
			c-0.587-1.056-1.145-2.072-1.696-3.038l10.579-10.565l5.2-5.207c6.46-6.46,6.639-16.778,0.419-23.001L42.715,4.769
			c-6.216-6.216-16.541-6.027-23.001,0.433l-8.818,8.868l0.243,0.24c-2.956,3.772-5.429,8.124-7.265,12.816
			c-1.696,4.466-2.752,8.729-3.235,12.998c-4.13,34.25,11.52,65.55,53.994,108.028c58.711,58.707,106.027,54.273,108.067,54.055
			c4.449-0.53,8.707-1.593,13.038-3.275c4.652-1.818,9.001-4.284,12.769-7.233l0.193,0.168l8.933-8.747
			C204.079,176.661,204.265,166.343,198.048,160.105z M190.683,176.164l-3.937,3.93l-1.568,1.507
			c-2.469,2.387-6.743,5.74-12.984,8.181c-3.543,1.364-7.036,2.24-10.59,2.663c-0.447,0.043-44.95,3.84-100.029-51.235
			C14.743,94.38,7.238,67.395,10.384,41.259c0.394-3.464,1.263-6.95,2.652-10.593c2.462-6.277,5.812-10.547,8.181-13.02l5.443-5.497
			c2.623-2.63,6.714-2.831,9.112-0.433l31.286,31.286c2.394,2.401,2.205,6.492-0.422,9.13L45.507,73.24l1.95,3.282
			c1.084,1.829,2.23,3.879,3.454,6.106c5.812,10.482,13.764,24.83,29.121,40.173c15.317,15.325,29.644,23.27,40.094,29.067
			c2.258,1.249,4.32,2.398,6.17,3.5l3.289,1.95l21.115-21.122c2.634-2.623,6.739-2.817,9.137-0.426l31.272,31.279
			C193.5,169.446,193.31,173.537,190.683,176.164z"
      fill="white"
    />
  </svg>
);

// 可重用的電話按鈕組件
const PhoneButton = ({
  phoneLink,
  text = '電話',
}: {
  phoneLink: string;
  text?: string;
}) => (
  <Button
    className="btn-green"
    style={{
      display: 'flex',
      alignItems: 'center',
    }}
    onClick={() => window.open(phoneLink)}
  >
    <PhoneIcon />
    {text}
  </Button>
);

// 可重用的返回按鈕組件
const BackButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    style={{
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#306166',
    }}
    onClick={onClick}
  >
    <ArrowLeftIcon />
    上一頁
  </Button>
);

// 診所卡片組件
const ClinicCard = ({
  name,
  address,
  phoneLink,
  onNavigate,
}: {
  name: string;
  address?: string;
  phoneLink: string;
  onNavigate: () => void;
}) => (
  <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
    <b>{name}</b>
    {address && <div>- {address}</div>}
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '1rem',
      }}
    >
      <Button onClick={onNavigate}>如何前往</Button>
      <div style={{ display: 'flex' }}>
        <PhoneButton phoneLink={phoneLink} />
      </div>
    </div>
  </div>
);

// 診所詳情組件
const ClinicDetail = ({
  clinicData,
}: {
  clinicData: (typeof CLINIC_DATA)[Exclude<Index, Index.Home>];
}) => (
  <>
    {clinicData.address && (
      <>
        <b>地址：</b>
        <h6>{clinicData.address}</h6>
      </>
    )}
    <p>
      <a className="tel" style={{ color: 'green' }} href={clinicData.phoneLink}>
        {clinicData.phone}
      </a>
    </p>
    {clinicData.directions && (
      <div style={{ marginTop: '2rem' }}>
        <b>前往方法：</b>
        {Array.isArray(clinicData.directions) ? (
          clinicData.directions.map((direction: string, index: number) => (
            <p key={index} style={{ fontSize: '14px', marginBottom: '1rem' }}>
              {index + 1}, {direction}
            </p>
          ))
        ) : (
          <h6>{clinicData.directions}</h6>
        )}
      </div>
    )}
    {clinicData.mapUrl && (
      <>
        <p style={{ marginTop: '2rem' }}>點擊地圖以使用 Google 地圖進行導航</p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <iframe
            title={`${clinicData.title}地圖`}
            src={clinicData.mapUrl}
            width="600"
            height="450"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </>
    )}
  </>
);

function Example() {
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(Index.Home);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleBooking = () => {
    window.open(bookingWhatsappUrl);
  };

  const renderClinicCard = (clinicIndex: Exclude<Index, Index.Home>) => {
    const clinic = CLINIC_DATA[clinicIndex];

    return (
      <ClinicCard
        name={clinic.name}
        address={clinic.address}
        phoneLink={clinic.phoneLink}
        onNavigate={() => setIndex(clinicIndex)}
      />
    );
  };

  const getTitle = () => {
    if (index === Index.Home)
      return (
        <Modal.Title>
          <b>分店資料</b>
        </Modal.Title>
      );
    return (
      <Modal.Title>
        <b>{CLINIC_DATA[index as Exclude<Index, Index.Home>].title}</b>
      </Modal.Title>
    );
  };

  const getBody = () => {
    if (index === Index.Home) {
      return <Modal.Body>{renderClinicCard(Index.KWAIFUNG)}</Modal.Body>;
    }

    return (
      <Modal.Body>
        <ClinicDetail
          clinicData={CLINIC_DATA[index as Exclude<Index, Index.Home>]}
        />
      </Modal.Body>
    );
  };

  const getFooter = () => {
    if (index === Index.Home) {
      return (
        <>
          {CLINIC_INDEXES.slice(1).map((clinicIndex) => (
            <Modal.Footer key={clinicIndex}>
              {renderClinicCard(clinicIndex)}
            </Modal.Footer>
          ))}
        </>
      );
    }

    return (
      <Modal.Footer>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <BackButton onClick={() => setIndex(Index.Home)} />
          <div style={{ display: 'flex' }}>
            <PhoneButton
              phoneLink={
                CLINIC_DATA[index as Exclude<Index, Index.Home>].phoneLink
              }
            />
          </div>
        </div>
      </Modal.Footer>
    );
  };

  return (
    <>
      <button
        type="button"
        aria-haspopup="dialog"
        aria-expanded={show}
        onClick={handleShow}
        className="float flex h-fit cursor-pointer flex-col items-center justify-center border
         border-[#306166] bg-[#306166] text-sm text-white md:h-[80px]
         md:w-[80px] md:text-base"
      >
        <span>預約</span>
        <span>診症</span>
      </button>

      <Modal
        className="booking-contact-modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>{getTitle()}</Modal.Header>
        {getBody()}
        {getFooter()}
        {index === Index.Home && (
          <Modal.Footer style={{ borderBottom: '0px' }}>
            <div className="booking-contact-actions">
              <Link
                to="/booking"
                className="btn-booking booking-contact-primary"
                onClick={handleClose}
              >
                立即預約
              </Link>
              <div className="booking-contact-methods">
                <PhoneButton phoneLink={'tel:+85296671254'} text="預約總線" />

                <button className="btn-booking" onClick={handleBooking}>
                  <img
                    src={whatsappIcon}
                    alt="WhatsApp"
                    className="mr-1 h-6 w-6 rounded-full"
                  />
                  預約總線
                </button>
              </div>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}

export default Example;
